var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addClient",
    attrs: {
      id: "add-client-modal",
      "modal-dialog-scrollable": false,
      "modal-footer": false,
      "modal-dialog-size": "md",
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.actions.addApplication")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { staticClass: "method-selection-screen" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.selectedMethod,
                        expression: "!selectedMethod",
                      },
                    ],
                  },
                  [
                    _c(
                      "transition",
                      {
                        key: "selecting",
                        attrs: {
                          name: "custom-classes-transition-2",
                          "enter-active-class": "animated fadeIn",
                        },
                      },
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "article",
                            { staticClass: "mb-0 method-selection" },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "application.messages.addApplicationTitle"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-container fe-radio-form large-radio col-lg-12 pb-3 px-0 w-100",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fe-option add-client-option begin-app-option",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedMethod,
                                            expression: "selectedMethod",
                                          },
                                        ],
                                        attrs: {
                                          id: "begin-an-app",
                                          type: "radio",
                                          name: "add-client-option",
                                          value: "full-application-method",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectedMethod,
                                            "full-application-method"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedMethod =
                                              "full-application-method"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "checkmark" }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "flex-column align-items-start justify-content-center",
                                          attrs: { for: "begin-an-app" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bold text-light-gray",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.messages.beginApplication"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-block text-light-gray",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "application.messages.beginApplication"
                                                  )
                                                ) +
                                                  " -\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.messages.beginApplicationSubtitle"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fe-option add-client-option",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedMethod,
                                            expression: "selectedMethod",
                                          },
                                        ],
                                        attrs: {
                                          id: "light-weight",
                                          type: "radio",
                                          name: "add-client-option",
                                          value: "simple-app-method",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectedMethod,
                                            "simple-app-method"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.selectedMethod =
                                              "simple-app-method"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "checkmark" }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "flex-column align-items-start justify-content-center",
                                          attrs: { for: "light-weight" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bold text-light-gray",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.messages.simpleApplication"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-block text-light-gray",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "application.messages.simpleApplicationSubtitle"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    key: "selected",
                    attrs: {
                      name: "custom-classes-transition",
                      "enter-active-class": "animated fadeIn",
                    },
                  },
                  [
                    _c(_vm.selectedMethod, {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedMethod,
                          expression: "selectedMethod",
                        },
                      ],
                      tag: "component",
                      class: { collapsed: !_vm.selectedMethod },
                      attrs: {
                        "client-details": _vm.clientDetails,
                        "request-personal-details": _vm.requestPersonalDetails,
                        "client-profile-id": _vm.clientProfileId,
                        additional: _vm.additional,
                        "client-username": _vm.clientUsername,
                        "agent-username": _vm.agentUsername,
                        "show-include-co-applicants":
                          _vm.showIncludeCoApplicants,
                      },
                      on: { back: _vm.resetSelectedMethod, hide: _vm.hide },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.selectedMethod
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start mt-3" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "white" },
                                    on: { click: _vm.hide },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("global.words.close")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }